import styled from "styled-components";
import React, { useState, useEffect } from "react";
import useViewerStore from '../../store-zustand/viewer';

const Wrapper = styled.div`
  z-index: 2;
  overflow: hidden;
  position: fixed;
  top: 3rem;
  right: 3rem;
  width: 32.2rem;
  color: ${({ theme }) => theme.textColor.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    top: 5rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    right: 5px;
    width: 150px;
    height: 220px;
  }
`;

const Content = styled.div`
  padding: 30px 19px 19px;
  position: relative;
  margin-top: 182px;
  background: #2F2F2F;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-top: 100px;
  }

  h3 {
    font-weight: bold;
    font-size: 15px;
    line-height: 22px;
    color: #E5E5E5;
    margin-bottom: 11px;
  }
`;

const StreetviewModal = () => {
    const { viewer, currentBBOX, RequestReverseGeocoding } = useViewerStore();
    const [country, setCountry] = useState();
    const [region, setRegion] = useState();
    const [place, setPlace] = useState();

    useEffect(() => {
        if (currentBBOX === undefined) return;

        var camera_position = viewer.camera.positionCartographic;
        let longitude = camera_position.longitude * (180 / Math.PI)
        let latitude = camera_position.latitude * (180 / Math.PI)
        RequestReverseGeocoding(longitude, latitude).then(response => {
            let country = '';
            let region = '';
            let place = '';
            for(let key in response.data.features){
                if (response.data.features[key].id.startsWith('country')) {
                    country = response.data.features[key].text;
                } else if (response.data.features[key].id.startsWith('region')) {
                    region = response.data.features[key].text;
                } else if (response.data.features[key].id.startsWith('place')){
                    place = response.data.features[key].text;
                }
            }
            setCountry(country);
            setRegion(region);
            setPlace(place);
        });

    }, [currentBBOX])

    return (
        <Wrapper>
            <Content>
                <h3>{country}</h3>
                <h4>{place}, {region}</h4>
            </Content>
        </Wrapper>
    );
};

export default StreetviewModal;